// dependencies
import { useNavigate } from "react-router";
import { saveAs } from "file-saver";

// components
import PrimaryBtn from "../../btns/PrimaryBtn";
import SecondaryBtn from "../../btns/SecondaryBtn";
import { FaLocationDot } from "react-icons/fa6";

// assets
import pfp_colour from "../../../assets/imgs/pfp_colour.jpg"
import cvPDF from "../../../assets/misc/Luca_Haar_Fullstack_Developer_2026.pdf"

// styles
import styles from "./css/HeroSection.module.css";



export default function HeroSection() {
    const navigate = useNavigate();

    const handleGetInContact = () => {
        navigate("/contact")
    }
    const handleDownloadCV = () => {
        fetch(cvPDF)
        .then((response) => response.blob())
        .then((blob) => {
            saveAs(blob, "Luca_Haar_Fullstack_Developer_2026.pdf");
        });
    }
    const handleViewWork = () => {
        navigate("/projects")
    }

    return (
        // background
        <div className={styles.heroSectionContainer}>
            {/* text, btns, location | img */}
            <div className={styles.contentContainer}>

                {/* text, btns */}
                <div className={styles.textContainer}>
                    <div className={styles.headerText}>
                        Hi, I'm <span className={styles.headerName}>Luca Haar</span>
                    </div>
                    <div className={styles.aboutText}>
                        I'm a junior fullstack developer specialising in mobile and web apps, focused on simplicity, functionality, and great user experience. 
                        <br />
                        Outside work, I experiment with game dev and AI.
                        <br />
                        This site shares my skills, projects, and explorations.
                    </div>
                    <div className={styles.locationContainer}>
                        <div className={styles.locationText}>
                            <FaLocationDot /> Melbourne, Australia
                        </div>
                    </div>
                    <div className={styles.btnsContainer}>
                        <PrimaryBtn text={"Get in Touch"} onClick={handleGetInContact} />
                        <PrimaryBtn text={"Download CV"} onClick={handleDownloadCV} />
                        <SecondaryBtn text={"View my Work"} onClick={handleViewWork} />
                    </div>
                </div>

                {/* img */}
                <div className={styles.imgContainer}>
                    <img src={pfp_colour} alt="luca-haar-profile" className={styles.img} />
                </div>
            </div>
        </div>
    );
}
